import React, { useRef, useState, useEffect, useLayoutEffect } from 'react';

import { RoundedLink } from './rounded.link';

import { ReactComponent as IZRUlogo } from '@assets/images/header/iz-logo.svg';

import { ReactComponent as NordStream2 } from '@assets/images/header/nord-stream-2.svg';
import { ReactComponent as NordStreamMobGradient2 } from '@assets/images/header/nord-stream-2-mob-gradient.svg';

import { ReactComponent as RectangleBlue } from '@assets/images/header/rectangle-blue.svg';
import { ReactComponent as RectangleWhite1 } from '@assets/images/header/rectangle-white-1.svg';
import { ReactComponent as RectangleWhite2 } from '@assets/images/header/rectangle-white-2.svg';

import { ReactComponent as RectangleBlueMobile } from '@assets/images/header/rectangle-blue-mobile.svg';
import { ReactComponent as RectangleWhite1Mobile } from '@assets/images/header/rectangle-white-1-mobile.svg';
import { ReactComponent as RectangleWhite2Mobile } from '@assets/images/header/rectangle-white-2-mobile.svg';

import { ReactComponent as RectangleWhite3 } from '@assets/images/header/rectangle-white-3.svg';
import { ReactComponent as RectangleWhite4 } from '@assets/images/header/rectangle-white-4.svg';
import { ReactComponent as RectangleWhite5 } from '@assets/images/header/rectangle-white-5.svg';

import { ReactComponent as FlagRu } from '@assets/images/header/flag-ru.svg';
import { ReactComponent as FlagDe } from '@assets/images/header/flag-de.svg';

import { ReactComponent as MenuOpen } from '@assets/images/menu/menu-open.svg';

import pipe from '@assets/images/header/pipe.webp';
import pipeMob from '@assets/images/header/pipe-mob.webp';
import pipeRing from '@assets/images/header/pipe-ring.webp';
import ring from '@assets/images/header/ring.webp';

import pipeSafari14 from '@assets/images/header/pipe-safari-14.png';
import pipeMobSafari14 from '@assets/images/header/pipe-mob-safari-14.png';
import pipeRingSafari14 from '@assets/images/header/pipe-ring-safari-14.png';
import ringSafari14 from '@assets/images/header/ring-safari-14.png';

import video1 from '@assets/video/video-1.mp4';

import styles from './index.module.css';

type PageHeaderProps = {
  onHidden: Function;
  onClick: () => void;
  show?: boolean;
  isDesktopOrLaptop?: any;
  onToggleMenu?: () => void;
  onActiveHeader: (boll: boolean) => void;
  open?: boolean;
  browser: any;
  scrollYPos: number;
  scrollDir?: string;
};

export const PageHeader: React.FC<PageHeaderProps> = ({ ...props }) => {
  const {
    onHidden,
    onClick,
    show,
    isDesktopOrLaptop,
    onToggleMenu,
    onActiveHeader,
    browser,
    scrollYPos,
    scrollDir
  } = props;
  const [active, setActive] = useState(false);
  const [hide, setHide] = useState(false);
  const [move, setMove] = useState(false);
  const [scrolly, setScrollY] = useState(0);

  const videoplayer = useRef<HTMLVideoElement>(null);

  const toggleHeight = () => {
    setHide(true);
    setMove(true);
    onClick();
    videoplayer.current?.pause();
    const timer = setTimeout(() => {
      onHidden();
      setActive(false);
      onActiveHeader(active);
      clearTimeout(timer);
    }, 3000);
  };

  useEffect(() => {
    if (!show) {
      setActive(true);
      onActiveHeader(active);
      setMove(false);
      setHide(false);
      const timer = setTimeout(() => {
        
        videoplayer.current?.play();
        clearTimeout(timer);
      }, 3000);
    }
  }, [show]);

  useEffect(() => {
    setActive(!active);
    onActiveHeader(active);
  }, []);

  useLayoutEffect(() => {
    let ticking = false;

    const onWheel = (e: any) => {
      e = e || window.event;
      var delta = e.deltaY || e.detail || e.wheelDelta;
      // if (delta > 0 && !hide) toggleHeight();
    }

    window.addEventListener('wheel', onWheel);
    return () => window.removeEventListener('wheel', onWheel);
  }, []);

  const browserName = browser.name.toLowerCase();
  const browserVersion = browser.version.split('.')[0];

  return (
    <header
      className={`
        ${active ? styles['header-active'] : ''}
        ${styles.header}
        ${hide? `overflow-visible` : `overflow-hidden`}
        fixed
        top-0
        left-0
        w-full
        h-full
        transform
        transition-all
        ${active ? `duration-2000` : `duration-75`}
        ${move? `-translate-y-8/4` : `-translate-y-0`}
      `}
      /* style={{ backgroundImage: `url(${bg})` }} */
    >
      <video
        ref={videoplayer}
        className={`
          absolute
          object-cover
          opacity-50
          h-full
          w-full
        `}
        width="320"
        height="240"
        autoPlay={true}
        muted={true}
        loop={true}
      >
        <source
          src={video1}
          type="video/mp4"
        />
      </video>
      <div className="flex flex-col items-center">
        <div
          className={`
            flex
            lg:inline-flex
            w-full
            lg:w-auto
            justify-between
            pl-4
            lg:pl-0
          `}
        >
          <a href="https://iz.ru" target="_blank" rel="noopener noreferrer">
            <IZRUlogo
              width={isDesktopOrLaptop ? 95 : 69}
              height={isDesktopOrLaptop ? 22 : 18}
              className={`
                opacity-0
                translate-y-full
                animation-delay-4000
                text-logo-dark
                mt-5
                lg:mt-8
                ${active ? `animate-opacity` : `opacity-inverse`}
              `}
            />
          </a>
          <span
            onClick={onToggleMenu}
            className={`
              block
              text-text-logo-dark
              lg:hidden
              cursor-pointer
              relative
              z-10
              px-5
              py-5
            `}
          >
            <MenuOpen
              width={24}
              height={24}
              className={`
                pb-1.5
                fill-current
              `}
            />
          </span>
        </div>
        <div className="relative mx-8 lg:mx-0 mt-16vw max-w-full">
          {isDesktopOrLaptop ?
            <React.Fragment>
              <NordStream2
                className={`
                  ${styles['stream-1']}
                  relative
                  z-2
                `}
              />
              <NordStream2
                className={`
                  ${styles['stream-2']}
                  absolute
                  top-0
                  z-3
                `}
              />
              <RectangleWhite1
                className={`
                  ${styles['rect-white-1']}
                  absolute z-1
                  -top-3.5vw
                  right-0
                  fill-current
                  text-white
                `}
              />
              <RectangleBlue
                className={`
                  ${styles['rect-blue']}
                  absolute
                  z-1
                  -left-10vw
                  -top-1.5vw
                `}
              />
              <RectangleWhite2
                className={`
                  ${styles['rect-white-2']}
                  absolute
                  z-1
                  left-3vw
                  -mt-3vw
                  fill-current
                  text-white
                `}
              />
            </React.Fragment>
            :
            <React.Fragment>
              <RectangleWhite1Mobile
                className={`
                  ${styles['rect-white-1']}
                  absolute left-0
                `}
              />
              <RectangleBlueMobile
                className={`
                  ${styles['rect-blue']}
                  absolute top-0 left-0 transform mt-8
                `}
              />
              <RectangleWhite2Mobile
                className={`
                  ${styles['rect-white-2']}
                  absolute -right-10 bottom-0.5 transform
                `}
              />
              <NordStreamMobGradient2
                className={`
                  ${styles['stream-1']}
                  max-w-full
                  h-auto
                  relative
                  z-2
                `}
              />
              <NordStreamMobGradient2
                className={`
                  ${styles['stream-2-mobile']}
                  max-w-full
                  h-auto
                  absolute
                  top-0
                  z-3
                `}
              />
            </React.Fragment>
          }

        </div>
        <h1
          className={`
            ${styles.title}
            ${active ? `animate-opacity-down` : ``}
            text-2.5xl
            lg:text-3xl
            font-bold
            text-transparent
            bg-clip-text
            bg-gradient-to-r
            from-dkblue-md
            to-dkblue
            mt-3.5
            mb-2
          `}
        >
          Шесть лет стройки
        </h1>
        <div
          className={`
            ${styles.text}
            ${active ? `animate-opacity-down-half` : ``}
            max-w-890
            font-medium
            text-center
            text-smsm
            lg:text-sm
            text-dkblue-md

            leading-32vh-important

            px-8
            lg:px-0
          `}
        >
          <span className="relative z-1">Подошла к концу шестилетняя история одной из крупнейших 
          газовых строек мира — завершено возведение второй нитки 
          газопровода </span><span className="relative z-0 inline-flex"><RectangleWhite3 className="absolute -left-8 z-1" /><span className="relative z-2">«Северный поток»</span></span>. 
          <span className="relative z-1"> О том, как шло строительство, какие препятствия его 
          создателям пришлось преодолеть и что новый трубопровод 
          способен дать России и Европе — </span><span className="relative z-0 inline-flex">{isDesktopOrLaptop && <RectangleWhite4 className="absolute -left-5 z-1" />}<span className="relative z-2">в спецпроекте «Известий»</span></span>. 
          <span className=" block mx-auto relative z-1"><span id="click-ring" onClick={toggleHeight} className={`${styles.clickMe} cursor-pointer animate-scale relative z-0 inline-flex`}><RectangleWhite5 className="absolute -left-5 z-1" /><span className="relative z-2">Кликай по вентилю, чтобы начать.</span></span></span>
        </div>
      </div>

      <div
        className={`
          ${styles.rore}
          ${active ? `animate-translate-y` : ``}
          relative
          w-full
        `}
      >
        {isDesktopOrLaptop ?
          <img
            className="
              relative
              z-1
              max-w-full
              w-full
              h-auto
            "
            src={(browserName === 'safari' && browserVersion < 15) ? pipeSafari14 :  pipe}
            width="1440"
            height="291"
            alt=""
          />
          :
          <img
            className="
              relative
              z-1
              max-w-full
              w-full
              h-auto
            "
            src={(browserName === 'safari' && browserVersion < 15) ? pipeMobSafari14 : pipeMob}
            width="375"
            height="138"
            alt=""
          />
        }
        {isDesktopOrLaptop && <React.Fragment>
          <FlagRu
            className="
              absolute
              top-2/4
              -mt-2vw
              lg:mt-2vw
              left-16vw
              lg:left-20vw
              z-2
            "
            width={122}
            height={80}
          />
          <FlagDe
            className="
              absolute
              top-2/4
              -mt-2vw
              lg:mt-2vw
              right-16vw
              lg:right-20vw
              z-2
            "
            width={122}
            height={80}
          />
        </React.Fragment>}
        <div
          onClick={toggleHeight}
          className={`
            absolute
            top-2/4
            left-2/4
            transform
            -translate-x-1/2
            -translate-y-1/3
            w-5/6
            lg:w-2/5
            z-2
            cursor-pointer
          `}
        >
          <img
            className={`
              absolute
              top-2/4
              left-2/4
              transform
              -translate-x-1/2
              -translate-y-1/2
              w-9/12
              h-9/12
              z-2
            `}
            src={(browserName === 'safari' && browserVersion < 15) ? pipeRingSafari14 : pipeRing}
            width="441"
            height="441"
            alt=""
          />
          {hide?
            <img
              className={`
                ${styles['ring-fast']}
                ${active ? `animate-rotate-fast` : ``}
                origin-center
                relative
                transform
                min-w-full
                min-h-full
                z-3
              `}
              src={(browserName === 'safari' && browserVersion < 15) ? ringSafari14 : ring}
              width="560"
              height="560"
              alt=""
            />
            :
            <img
              className={`
                ${active ? `animate-rotate` : ``}
                ${styles.ring}

                origin-center
                relative
                transform
                min-w-full
                min-h-full
                z-3
              `}
              src={(browserName === 'safari' && browserVersion < 15) ? ringSafari14 : ring}
              width="560"
              height="560"
              alt=""
            />
          }
        </div>
      </div>

      {isDesktopOrLaptop && <RoundedLink id={`dark`} color={``}  />}

    </header>
  );
};
